// Recovered compiled webpack factory 78305. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return e.replace(/\\/g, "/");
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "normalizePathSep", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
